import React, { useEffect, useState } from "react";
import { IFilterCategory } from "../../../../types/category.type";
import FilterText from "../FilterText";
import WrapperFilter from "../WrapperFilter";
import FilterSelectApi from "../FilterSelectApi";

function FilterHangVeXe({ setCondition }: IFilterCategory) {
  const originFilter: { [key: string]: any } = {
    ma: "",
    ten: "",
    tuyen_duong: null,
    nha_xe: null,
    loai_xe: null,
  };
  const [filter, setFilter] = useState<{ [key: string]: any }>(originFilter);
  const [toggleClear, setToggleClear] = useState<number>(0);

  const refreshFilter = () => {
    setFilter(originFilter);
    setToggleClear(toggleClear + 1);
  };

  useEffect(() => {
    const condition: { [key: string]: any } = {};
    if (filter.ma) {
      condition.ma = {
        $regex: filter.ma?.split(" ").join(".*"),
        $options: "i",
      };
    }
    if (filter.ten) {
      condition.ten = {
        $regex: filter.ten?.split(" ").join(".*"),
        $options: "i",
      };
    }
    if (filter.tuyen_duong) {
      condition.route = filter.tuyen_duong?._id;
    }
    if (filter.nha_xe) {
      condition.nhaxe = filter.nha_xe.ma_dt;
    }
    if (filter.loai_xe) {
      condition.loaixe = filter.loai_xe?._id;
    }
    setCondition(condition);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filter]);

  return (
    <WrapperFilter refreshFilter={refreshFilter}>
      <FilterText
        label="Mã"
        placeholder="Tìm theo mã"
        value={filter.ma}
        onSearch={(val) => setFilter({ ...filter, ma: val })}
      />
      <FilterText
        label="Tên"
        placeholder="Tìm theo tên"
        value={filter.ten}
        onSearch={(val) => setFilter({ ...filter, ten: val })}
      />
      <FilterSelectApi
        label="Tuyến đường"
        placeholder="Chọn tuyến đường"
        selectTitle="Chọn tuyến đường"
        placeholderSearch="Tìm theo mã, tên tuyến đường"
        apiCode="route"
        getOptionLabel={(option) => option.name}
        checkEqual={(value, option) => value?._id === option?._id}
        searchFields={["name"]}
        value={filter.tuyen_duong}
        onChange={(val) => setFilter({ ...filter, tuyen_duong: val })}
      />
      <FilterSelectApi
        label="Nhà xe"
        placeholder="Chọn nhà xe"
        selectTitle="Chọn nhà xe"
        placeholderSearch="Tìm theo mã, tên nhà xe"
        apiCode="dmnhaxe"
        getOptionLabel={(option) => option.ten_dt}
        checkEqual={(value, option) => value?.ma_dt === option?.ma_dt}
        searchFields={["ma_dt", "ten_dt"]}
        value={filter.nha_xe}
        onChange={(val) => setFilter({ ...filter, nha_xe: val })}
      />
      <FilterSelectApi
        label="Loại xe"
        placeholder="Chọn loại xe"
        selectTitle="Chọn loại xe"
        placeholderSearch="Tìm theo tên loại xe"
        apiCode="dmloaixe"
        getOptionLabel={(option) => option.name}
        checkEqual={(value, option) => value?._id === option?._id}
        searchFields={["name"]}
        value={filter.loai_xe}
        onChange={(val) => setFilter({ ...filter, loai_xe: val })}
      />
    </WrapperFilter>
  );
}

export default FilterHangVeXe;
